module.exports = __webpack_public_path__ + "media/customizations/growfield/logo-new-12d8f422984519270b68a956d42b2e01.png";